// Memorial entry for Col. Asaf Hamami
import asafHamamiPortrait from '../../../images/asaf-hamami.jpg';

export const asafHamamiMemorial = {
  id: 39,
  name: 'Col. Asaf Hamami',
  images: {
    portrait: asafHamamiPortrait
  },
  info: `
"We are at war, everything is fine, war." - The first declaration of war on October 7, at 6:44 AM

# Colonel Asaf Hamami

![Col. Asaf Hamami](${asafHamamiPortrait})
*Colonel Asaf Hamami, 40, Southern Brigade Commander - first to declare war*

## The First to Declare War

At 6:44 AM on October 7, 2023, Colonel Asaf Hamami issued the first formal declaration of war via radio: "We are at war, everything is fine, war."

He was spending Simchat Torah at the Gaza Division base with his 5-year-old son Alon. When the attack began, he entrusted his son to soldiers and ran toward the enemy.

At 40, Hamami had served 22 years in the IDF, earning a Chief of Staff Citation, commanding multiple battalions, and becoming commander of the Southern Brigade. He held bachelor's and master's degrees in Political Science and Security.

## The Stand at Nirim

At 6:47 AM, Hamami and two soldiers - Staff Sgt. Tomer Ahimas, 20, and Sgt. Kiril Brodski, 19 - arrived at Kibbutz Nirim in a light armored vehicle. They were the only military force against dozens of terrorists.

They killed three militants in a 20-minute firefight. Then Hamami was shot in the thigh. His soldiers tried to save him while exchanging fire.

"Brigade commander wounded, must evacuate immediately, now!" they called on the radio. No response came. The chaos was overwhelming.

By 7:10 AM, all three were dead. Hamas had been hunting for Hamami - captured terrorists carried his photograph.

Nirim residents said: "Without their bravery, the kibbutz would have absorbed an even greater tragedy."

## Coming Home

Hamami became the most senior officer taken hostage. His remains returned November 2, 2025 - 578 days later.

At his funeral, a recording of his declaration of war was played. His wife Saphir spoke: "You were the perfect partner. The deal was you take care of the country and I take care of everything else."

His mother Clara: "Asaf has come home. It's not the home we wanted, but he's here to rest."

His father revealed Asaf once wrote: "If I'm ever taken captive - I won't enter alive. Don't make deals for me."

IDF Chief of Staff Zamir: "Rest in peace, war hero, for the victory was achieved."

*To be good - to be Hamami. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/col-asaf-hamami-41-witty-commander-did-not-hesitate-for-a-moment/)
`
};
